import { defineStore } from 'pinia'
import { getWebActivityConfig } from '@/api/modules/mall4cloud_admin.js'
import { handleRequestError } from '@/api/error.js'
export const useWebConfigStore = defineStore('webConfigStore', {
  state: () => {
    return {
      webConfig: {
        // 登录logo
        loginLogoImg: '',
        // 标题
        titleContent: '',
        // 欢迎语
        h5Welcome: '',
        // 主页tab首页开关
        home: 0,
        // 主页tab附近开关
        nearby: 0
      }
    }
  },
  actions: {
    async getUniWebConfig () {
      const params = {
        data: {
          webConfigType: 'H5_WEBSITE_CONFIG'
        }
      }
      try {
        const res = await getWebActivityConfig(params)
        if (!res) return
        this.webConfig.loginLogoImg = util.checkFileUrl(res.loginLogoImg)
        this.webConfig.titleContent = res.titleContentCn || '地利商城'
        this.webConfig.h5Welcome = res.h5WelcomeCn
        this.webConfig.home = res.home
        this.webConfig.nearby = res.nearby
        setTimeout(() => {
          uni.$emit('configChange', this.webConfig)
        }, 100)
      } catch (error) {
        handleRequestError(error)
      }
    }
  }
})
